export const partService = {
    searchPart,
    searchSchemes
};

async function searchPart(
    partNumber,
    limit,
    offset
) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/car-search?`  + new URLSearchParams({
        part_number: partNumber,
        limit: limit,
        offset: offset
    }), requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function searchSchemes(
    partNumber,
    carTypeId
) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/scheme-search?`  + new URLSearchParams({
        part_number: partNumber,
        car_type_id: carTypeId
    }), requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}